import React from "react";
import { AddSubject } from "./AddSubject";
import { Card } from "../card";
import { ListSubjects } from "./ListSubjects/ListSubjects";
import { GridWrapper } from "../GridWrapper/GridWrapper";

export const SubjectComponent = () => {
  return (
    <GridWrapper
      totalColumns={3}
      childrens={[
        {
          component: (
            <Card wrapperStyle={{ height: "100%" }} cardTitle="Add subject">
              <div>
                <AddSubject />
              </div>
            </Card>
          ),
          gridSpan: 1,
        },
        {
          component: (
            <Card wrapperStyle={{ height: "100%" }} cardTitle="All subjects">
              <ListSubjects />
            </Card>
          ),
          gridSpan: 2,
        },
      ]}
    />
  );
};
